export const dividerBorderLight = {
  borderColor: '#F3F3F3',
};

export const inputBorderLight = {
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
  '& .MuiInputBase-input': { padding: '16px 14px' },
  backgroundColor: 'primary.light',
  fontSize: '12px'
};